import { render, staticRenderFns } from "./IndividualSubscriptionRedirect.vue?vue&type=template&id=95795922&"
import script from "./IndividualSubscriptionRedirect.vue?vue&type=script&lang=js&"
export * from "./IndividualSubscriptionRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports